"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styletronReact = require("styletron-react");

var _checkbox = require("../checkbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const MultiOptionContent = props => {
  const {
    children,
    isSelected
  } = props;
  const [css] = (0, _styletronReact.useStyletron)();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css({
      display: 'flex',
      alignItems: 'center'
    })
  }, /*#__PURE__*/_react.default.createElement(_checkbox.Checkbox, {
    checked: isSelected,
    size: "small",
    overrides: {
      Label: {
        style: {
          // The label has left padding by default
          paddingLeft: 0
        }
      }
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: css({
      marginLeft: '0.5rem'
    })
  }, children));
};

var _default = MultiOptionContent;
exports.default = _default;